import apiCallTemplate from './servicesConfig'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const usersURL = `${BASE_URL}/users`;

//Get all users
export const allUsers=async (query)=>apiCallTemplate("get", `${usersURL}${query}`)

//User Profile
export const myProfile=async (query)=>apiCallTemplate("get", `${usersURL}/profile/me/${query || "me"}`)

//User Profile Fan Page
export const myProfileFanPage=async (username)=>apiCallTemplate("get", `${usersURL}/fanpage/profile/${username}`)

//Update User Profile
export const UpdateProfile=async (id, data)=>apiCallTemplate("put", `${usersURL}/edit-profile/${id}`, data)

//Delete User
export const deleteUser=async (id)=>apiCallTemplate("delete", `${usersURL}/${id}`)

//Users Statistics
export const userStatistics=async ()=>apiCallTemplate("get", `${usersURL}/get/statistics`)

//Contacts Us
export const contactUs=async (data)=>apiCallTemplate("post", `${usersURL}/contact-us`, data)